import React from 'react';
import s from '../../PromoBadge.scss';
const HexagonUnlocked24 = ({ className  })=>/*#__PURE__*/ React.createElement("svg", {
        className: className,
        width: "24",
        height: "24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        opacity: "0.1",
        d: "M11 .577a2 2 0 0 1 2 0l8.392 4.846a2 2 0 0 1 1 1.732v9.69a2 2 0 0 1-1 1.732L13 23.423a2 2 0 0 1-2 0l-8.392-4.846a2 2 0 0 1-1-1.732v-9.69a2 2 0 0 1 1-1.732L11 .577Z",
        className: s['fill-color']
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M11 2.577a2 2 0 0 1 2 0l6.66 3.846a2 2 0 0 1 1 1.732v7.69a2 2 0 0 1-1 1.732L13 21.423a2 2 0 0 1-2 0l-6.66-3.846a2 2 0 0 1-1-1.732v-7.69a2 2 0 0 1 1-1.732L11 2.577Z",
        className: s['fill-color']
    }));
HexagonUnlocked24.displayName = 'HexagonUnlocked24';
export default HexagonUnlocked24;
